var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"mt-6",attrs:{"size":50,"width":5,"indeterminate":"","color":"primary"}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }